import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import "../css/loader.css";
import { RingLoader } from "react-spinners";

const Loader = ({ onLoadComplete }) => {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFadeOut(true);
      setTimeout(() => {
        if (onLoadComplete) {
          onLoadComplete();
        }
      }, 500); 
    }, 3500); 

    return () => clearTimeout(timer);
  }, [onLoadComplete]);

  return (
    <motion.div
      className="loader-overlay"
      initial={{ opacity: 1 }}
      animate={{ opacity: fadeOut ? 0 : 1 }}
      transition={{ duration: 0.5 }}
    >
      <RingLoader size={50} color="#ffffff" speedMultiplier={1.2} />
    </motion.div>
  );
};

export default Loader;
